/**
 * Browser-side mirror of the engine's pure template metadata. No React/Remotion
 * imports — after the Hyperframes migration the UI builds compositions as
 * HTML strings via `lib/hyperframesCompositions.ts`.
 */
import {
  calcReelDurationFrames,
  resolveClipLayout,
} from "@engine/compositions/reelShape";

export { calcReelDurationFrames, resolveClipLayout };

export const FORMAT_DIMENSIONS: Record<
  string,
  { width: number; height: number; label: string; aspect: string }
> = {
  "9:16": { width: 1080, height: 1920, label: "Reels / TikTok / Shorts", aspect: "9:16" },
  "1:1": { width: 1080, height: 1080, label: "Instagram Feed", aspect: "1:1" },
  "16:9": { width: 1920, height: 1080, label: "YouTube / Website", aspect: "16:9" },
};

export const FPS = 30;

export function audienceForIdea(id: string): "b2c" | "b2b" | "affiliate" | "brand" {
  if (
    id.startsWith("ally_001") ||
    id.startsWith("ally_002") ||
    id.startsWith("ally_003") ||
    id.startsWith("ally_004") ||
    id.startsWith("ally_005") ||
    id.startsWith("ally_006")
  ) {
    return "b2c";
  }
  if (id.startsWith("ally_01")) return "b2b";
  if (id.startsWith("ally_02")) return "affiliate";
  if (id.startsWith("ally_03")) return "brand";
  return "brand";
}

export function audienceLabel(a: ReturnType<typeof audienceForIdea>): string {
  return {
    b2c: "Endkunden",
    b2b: "Händler / Partner",
    affiliate: "Vertriebler",
    brand: "Brand & Vision",
  }[a];
}
